import TSettingIVRList from './index.vue';

TSettingIVRList.install = app => {
  app.component(TSettingIVRList.name, TSettingIVRList);
};

export default TSettingIVRList;
